<template>
	<div
		class="g-block-title-split-box g-block-title-padding"
		:class="{
			'g-block-title-split-box--edit': editable,
			'is-active': editable && active,
			'g-block-title-split-box--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-split-box__row">
			<div class="g-block-title-split-box__left" :style="{ borderColor: themeColor, color: themeColor }">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-split-box__text"
					fit-content
					:model-value="data.primaryText"
					placeholder="左侧文字"
					@update:model-value="onPrimaryUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-split-box__text"
					v-html="data.primaryText || ''"
				></div>
			</div>
			<div class="g-block-title-split-box__right" :style="{ background: themeColor }">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-split-box__text g-block-title-split-box__text--inverse"
					fit-content
					:model-value="data.secondaryText"
					placeholder="右侧文字"
					@update:model-value="onSecondaryUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-split-box__text g-block-title-split-box__text--inverse"
					v-html="data.secondaryText || ''"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { dualTitleMixin } from '../shared/dualTitleMixin.js';

	export default {
		name: 'GBlockTitleSplitBox',
		components: { RichTextEditable },
		mixins: [dualTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-split-box {
		.title-block-edit-shell();
		text-align: center;
	}

	.g-block-title-split-box__row {
		display: inline-flex;
		align-items: stretch;
		max-width: 100%;
	}

	.g-block-title-split-box__left,
	.g-block-title-split-box__right {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 18px;
		box-sizing: border-box;
	}

	.g-block-title-split-box__left {
		background: #fff;
		border: 1px solid;
	}

	.g-block-title-split-box__text {
		font-size: 18px;
		font-weight: 400;
		line-height: 1.3;
		text-align: center;
		color: inherit;

		&--inverse {
			color: #fff;
		}

		:deep(.g-rich-text-editable__content) {
			min-height: unset;
			padding: 0;
			color: inherit;
			text-align: center;
		}
	}

	.g-block-title-split-box--h5 {
		.g-block-title-split-box__left,
		.g-block-title-split-box__right { padding: 0.2rem 0.36rem; }
		.g-block-title-split-box__text { font-size: 0.36rem; }
	}
</style>
